import API from '../../lib/api'
import base from './base'

const api = new API(1, 'genders')
const baseModule = base(api);

export default {
	namespaced: true,
	state: baseModule.state,
	getters: baseModule.getters,
	actions: {
		getList: baseModule.actions.getList
	},
	mutations: {
		setList: baseModule.mutations.setList
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/gender.js